<script setup lang="ts">
import { Heart } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import useFavorites from '@/composables/useFavorites.ts';

const { isFavorite, toggleEntry } = useFavorites();

defineProps<{
    uid: string;
}>();
</script>

<template>
    <Button
        variant="outline"
        size="icon"
        @click="() => toggleEntry(uid)"
    >
        <Heart :fill="isFavorite(uid) ? 'currentColor' : 'none'" />
    </Button>
</template>
